<span class="msa-callout__content">
  @if (title()) {
    <strong class="msa-callout__title">{{ title() }}</strong>
  }
  {{ message() }}
</span>
@if (dismissible()) {
  <lib-button
    icon="✕"
    variant="ghost"
    color="neutral"
    size="sm"
    label="Close"
    (clicked)="onDismiss()"
  />
}
